import { createContext } from 'react'

interface context {
    user: any;
    modules: {route: string, displayName: string, icon: Object}[];
    hasModule: (route: string) => boolean
}

const userContext = createContext<context>({user: "user", modules: [], hasModule: () => false});

export {
    userContext
}